// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-narative-gatsby-theme-novela-src-templates-articles-template-tsx": () => import("../node_modules/@narative/gatsby-theme-novela/src/templates/articles.template.tsx" /* webpackChunkName: "component---node-modules-narative-gatsby-theme-novela-src-templates-articles-template-tsx" */),
  "component---node-modules-narative-gatsby-theme-novela-src-templates-article-template-tsx": () => import("../node_modules/@narative/gatsby-theme-novela/src/templates/article.template.tsx" /* webpackChunkName: "component---node-modules-narative-gatsby-theme-novela-src-templates-article-template-tsx" */)
}

